var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsOther = function SvgDotsOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0M5 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0M1 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0M6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M0 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
  })));
};
export default SvgDotsOther;